module.exports = __webpack_public_path__ + "static/img/video-img.960842f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video-img.jpg
// module id = BM5T
// module chunks = 1